export default function Spacer({ width = 0, height = 0 }) {
  return <div style={{ width: `${width}px`, height: `${height}px` }}></div>;
}
